import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import SearchBar from "../Components/SearchBar";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Forecast = () => {

  const currentMonthIndex = new Date().getMonth();

  const [inputData, setInputData] = useState({
    January: "",
    February: "",
    March: "",
    April: "",
    May: "",
    June: "",
    July: "",
    August: "",
    September: "",
    October: "",
    November: "",
    December: "",
  });
  //
  // Define months array
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Define short months array
  const shortMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const spacedSupplierId = localStorage.getItem("currentUser");
        const supplierId = spacedSupplierId.replace(/\s/g, "");
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASEURL}/api/forecast/${supplierId}`,
          {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              }
          }
        );
        const monthData = response.data;

        setInputData((prevInputData) => {
          const updatedInputData = { ...prevInputData };

          // Iterate over monthData and update the corresponding month's input value
          for (const { month, value } of monthData) {
            updatedInputData[ months[ shortMonths.indexOf(month) ] ] = value !== null ? String(value) : ""; // Convert value to string for placeholders
          }

          return updatedInputData;
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    const inputMonthIndex = months.indexOf(name);

    // Only allow input for upcoming and current months
    //if (inputMonthIndex > new Date().getMonth()) {
      setInputData({
        ...inputData,
        [name]: value === "" ? "" : parseInt(value, 10),
      });
    //}
  };

  const handleSaveClick = async () => {
    try {
      const currentYear = new Date().getFullYear();

      // Filter out disabled months (those with empty or undefined values)
      const activeMonthData = months
        .filter(
          (month) => inputData[month] !== "" && inputData[month] !== undefined
        )
        .map((month) => ({
          month,
          value: parseInt(inputData[month]),
        }
        )
        );
        const allInputValue = {
          year: currentYear,
          month: activeMonthData,
        };

      const response = await axios.post(
        process.env.REACT_APP_API_BASEURL + "/api/forecast",
        allInputValue
      );

      if (response.status === 200) {
        console.log("Forecast saved successfully!");
      } else {
        console.error("Error saving data.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
const notify=()=>{
  toast.success('🦄 Forecast Saved Successfully!', {
position: "top-center",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});

}
  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Forecast</a>
          </div>
          <div className="" id="result-wrapper">
            <SearchBar />

            <table className="custome-theme" id="result">
              <tbody>
                <tr className="date">
                  <td className="forecastTableHeader" colSpan="4">
                    {new Date().getFullYear()} Forecast Volumes
                  </td>
                </tr>
                {months.map((month, index) => (
                  <tr className="green" key={month}>
                    <td className="odd heading forecastTableRow">
                      <label>{month}</label>
                    </td>
                    <td className="odd forecastTableRow data-table-main">
                      <input
                        value={inputData[month]}
                        onChange={handleInput}
                        className="forecastInput"
                        id={`txt_${index + 1}`}
                        name={month}
                        disabled={index < currentMonthIndex}
                        type="number"
                      />
                    </td>
                  </tr>
                ))}
                <tr>
                  <td />
                  <td />
                </tr>
              </tbody>
            </table>

            <div className="button-theme">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xs-6" style={{ cursor: "pointer" }}>
                    <div
                      className="saveBtn"
                      id="forecastSave"
                      type="submit"
                      onClick={()=>{

                        handleSaveClick();
                        notify()
                      }
                      }
                    >
                      <a>
                        <i className="icon fas fa-save" /> <span>SAVE</span>
                      </a>
                    </div>
                  </div>

                  <div className="col-xs-6">
                    <div className="cancelBtn" id="forecastCancel">
                      <a>
                        <i className="icon fas fa-times" />
                        <span>CANCEL</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forecast;
